import React from "react";
import firebase from "firebase/compat";

import UserData from "../data/UserData";

export type UseOrganizationUsersProps = {
  organizationId?: string | null;
};

const useOrganizationUsers = ({
  organizationId,
}: UseOrganizationUsersProps) => {
  const [organizationUsers, setOrganizationUsers] =
    React.useState<firebase.firestore.DocumentData[]>();

  const getData = async () => {
    const users = await UserData.getOrganizationUsers();
    setOrganizationUsers(users);
  };

  React.useEffect(() => {
    getData();
  }, [organizationId]);

  return organizationUsers;
};

export default useOrganizationUsers;
